<template lang="pug">
  .column
    .row.middle.center
      simple-svg.gray-icon.search-icon.m4-right-2(:filepath='mailIcon' :width='"37px"' :height='"37px"')
      .input-container.width-100(:class='{ checked: confirmed || checked, pending: pending }')
        input.input-border.trial-input.text-normal(
          type='email'
          name='inputEmail'
          v-model='inputEmail'
          :placeholder='$t("trialInvite.emailPlaceholder")'
          :disabled='confirmed'
          @input='updateEmail(inputEmail, inputIndex)'
          :class='{ blocked: confirmed, error: showErrors }'
        )
    .row.middle.m4-left-12(v-if='showErrors && ($v.$invalid || usedEmail)')
      simple-svg.stop-icon.red-icon(:filepath='stopIcon' :width='"14px"' :height='"14px"')
      p.red(v-if='invalidEmail')
        | {{ $t('trialInvite.invalidEmailError') }}
      p.red(v-else='usedEmail')
        | {{ $t('trialInvite.usedEmailError') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'

import mailIcon from '@/assets/ic_mail_circle.svg'
import checkIcon from '@/assets/ic_check-incircle.svg'
import stopIcon from '@/assets/ic_stop.svg'

import { usedMailInSchool } from '../../services/UserService'
import { email } from 'vuelidate/lib/validators'
import { emailRegex } from '../../utils/validators'

let timer = null

export default {
  props: {
    inputIndex: { type: Number },
    type: { type: String },
    propEmail: { type: String }
  },
  data() {
    return {
      mailIcon,
      checkIcon,
      stopIcon,
      inputEmail: this.propEmail,
      checked: false,
      showErrors: false,
      usedEmail: false,
      changed: false
    }
  },
  validations: {
    inputEmail: { email, emailRegex }
  },
  computed: {
    ...mapState({
      emails: state => state.trial.emailsToInvite
    }),
    confirmed() {
      return this.type === 'confirmed'
    },
    pending() {
      return this.type === 'pending' && !this.changed
    },
    invalidEmail() {
      return this.showErrors && (!this.$v.inputEmail.email || !this.$v.inputEmail.emailRegex)
    }
  },
  methods: {
    ...mapActions([
      'updateTrialEmail',
      'hideElement'
    ]),
    updateEmail(inputEmail, inputIndex) {
      this.changed = true
      this.checked = false
      this.usedEmail = false
      this.showErrors = false
      this.checkEmail()
      this.updateTrialEmail({ inputEmail, inputIndex })
    },
    checkEmail() {
      clearTimeout(timer)
      timer = setTimeout(() => {
        if (this.$v.$invalid) {
          this.showErrors = true
          this.$parent.$emit('inputState', true, this.inputIndex)
        } else {
          this.showErrors = false
          this.checkUsedEmail()
        }
      }, 1500)
    },
    checkUsedEmail() {
      if (this.inputEmail !== '') {
        clearTimeout(timer)
        const emailCount = this.emails.filter(email => email === this.inputEmail).length
        if (emailCount >= 2) {
          this.usedEmail = true
          this.showErrors = true
          this.$parent.$emit('inputState', true, this.inputIndex)
        } else {
          timer = setTimeout(async () => {
            const response = await usedMailInSchool({ email: this.inputEmail }).catch(e => e.response)
            this.usedEmail = response.data
            if (response.data) {
              this.showErrors = true
              this.$parent.$emit('inputState', true, this.inputIndex)
            } else {
              this.showErrors = false
              this.checked = true
              this.$parent.$emit('inputState', false, this.inputIndex)
            }
          }, 500)
        }
      } else this.$parent.$emit('inputState', false, this.inputIndex)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';
@import '../../scss/variables/_z-indexes.scss';

.search-icon {
  padding-top: 4px;
}

.trial-input {
  color: $black;
  margin-top: 0;
  padding-right: 40px;
  position: relative;

  &:focus {
    border-color: $blue;
  }

  &.blocked {
    background-color: $light-gray;
  }

  &.error {
    border-color: $red;
  }
}

.input-container {
  position: relative;

  &.checked::after {
    background: url('../../assets/ic_check-incircle.svg') no-repeat;
    background-size: 100%;
    content: '';
    height: 18px;
    position: absolute;
    right: 15px;
    top: 12px;
    width: 18px;
    z-index: $tabsZindex;
  }

  &.pending::after {
    background: url('../../assets/ic_clock.svg') no-repeat;
    background-size: 100%;
    content: '';
    height: 18px;
    position: absolute;
    right: 15px;
    top: 12px;
    width: 18px;
    z-index: $tabsZindex;
  }
}

.check-icon {
  margin-top: 2px;
  position: absolute;
  right: 360px;
}

.stop-icon {
  margin-right: 6px;
}
</style>
